export default __webpack_public_path__ + "static/media/ic_chatavatar.7ae097ee.svg";